
import { useAuth0 } from "@auth0/auth0-react";
import { datadogRum } from "@datadog/browser-rum";

export function initDataDog() {
    if (
        window.location.hostname === "localhost"
    ) {
        console.log("Data Dog is disabled");
        return;
    }
    
    datadogRum.init({
        applicationId: process.env.REACT_APP_APP_ID,
        clientToken: process.env.REACT_APP_CLIENT_TOKEN,
        site: process.env.REACT_APP_DATADOG_SITE,
        service:'opus',
        env: process.env.REACT_APP_ENV,
        // Specify a version number to identify the deployed version of your application in Datadog
        // version: '1.0.0',
        sessionSampleRate:  100,
        sessionReplaySampleRate: 20,
        defaultPrivacyLevel: 'mask-user-input',
    });

}

export function useDataDogIdentifyUser() {
    const { user } = useAuth0();

    if (user) {
        datadogRum.setUser({
            id: user.sub,
            name: user.name,
            email: user.email,
        });
    }
}
